import { AppointmentRequestSummary } from 'apps/wrapper/src/services/appointment/types/appointment-request-summary';
import { EventApptRequestsWidget } from 'apps/wrapper/src/types/event-bus';
import { createContext } from 'react';
import { AppointmentRequestsFilter } from '../../../../../../types/appointment-request/appointment-requests-filter';
import { ApptRequestsWidgetRoute } from '../../navigation/route-config';

export interface ApptRequestsWidgetContextProps {
  events: {
    widgetEvent?: EventApptRequestsWidget | undefined;
  };
  routeHistory: ApptRequestsWidgetRoute[];
  route: ApptRequestsWidgetRoute | undefined;
  goTo: (route: ApptRequestsWidgetRoute, skipEventBus?: boolean) => void;
  goBack: (fallbackToMainPage?: boolean) => void;
  goToCalendarApp: () => Promise<void>;
  isLoading: boolean;
  isLoadingMoreApptRequests: boolean;
  locationId: number;
  locationName: string;
  appointmentRequests: AppointmentRequestSummary[];
  allApptRequestsLoaded: boolean;
  loadMoreApptRequests: () => Promise<void>;
  appointmentRequestsFilter: AppointmentRequestsFilter | undefined;
  setAppointmentRequestsFilter: (filter: AppointmentRequestsFilter | undefined) => void;
  markRequestAsRead: (id: number) => void;
  listScrollTop: number;
  setListScrollTop: (top: number) => void;
}

export const ApptRequestsWidgetContext = createContext<ApptRequestsWidgetContextProps>(null!);
